<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <contractor-check-out-page /><br><br><br>
    </div>
  </div>
</template>
    <script>
    import ContractorCheckOutPage from '../../../Components/Contractor/ContractorCheckOutPage.vue';
      export default {
        name: 'VisitorCheckInPage',
        components: {
          'contractor-check-out-page': ContractorCheckOutPage,
      },
    };
    </script>
<style scoped>
</style>
